import { CdkMenuModule } from '@angular/cdk/menu';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { EnvironmentBannerComponent } from './components/environment-banner/environment-banner.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    OverlayModule,
    CdkMenuModule,
    CommonModule,
    EnvironmentBannerComponent

  ],
  template: `
  <app-environment-banner></app-environment-banner>
  <router-outlet></router-outlet> `,
  styles: [
    `
    `,
  ],
})
export class AppComponent {
 /* authService = inject(AuthService);
  http = inject(HttpClient);



  logout(): void {
      sessionStorage.setItem('token', '');
    this.authService.currentUserSig.set(null);
  }

 title = 'SICRED';
  collapsed = signal(false);
  sideNavWidth = computed(() => (this.collapsed() ? '65px' : '100px'));
  */
}
